import React, { useState } from "react";
import Select, {components} from "react-select";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const DefaultDropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowDropDownIcon/>
      </components.DropdownIndicator>
    );
  };

const ReactSelectMultiSelect = (props) => {
    const [isClearable, setIsClearable] = useState(true);
    const { 
      name, 
      eleRef, 
      className, 
      options, 
      ValueContainer, 
      styles, 
      onChange, 
      value, 
      isMulti, 
      isClearableCheck, 
      placeholder, 
      defaultValue, 
      components: customComponents, 
      isDisabled, 
      classNamePrefix = 'prov', 
      error 
    } = props

    const mergedComponents = {
        DropdownIndicator: DefaultDropdownIndicator,
        ...(customComponents || {}),
        ...(ValueContainer ? { ValueContainer } : {}),
    };

    // merge user styles with an override for the control when `error` is true
    const mergedStyles = {
      ...(styles || {}),
      control: (provided, state) => {
        // allow user's control style to be a function or an object
        const userControl = styles && styles.control;
        const base = typeof userControl === 'function'
          ? userControl(provided, state)
          : { ...provided, ...(userControl || {}) };

        if (!error) {
          return base;
        }

        // error visual (adjust colors as needed)
        const errorBorder = {
          // ensure a visible border by default
          border: '1px solid #d32f2f',
          borderColor: '#d32f2f',
          // show subtle focus ring when focused, otherwise keep no shadow
          boxShadow: state.isFocused ? '0 0 0 1px rgba(211,47,47,0.25)' : 'none',
          '&:hover': {
            borderColor: '#d32f2f',
          }
        };

        return { ...base, ...errorBorder };
      }
    };

    return (
        <Select
            menuPortalTarget={document.body} menuPosition={'fixed'}
            name={name}
            ref={eleRef}
            className={className}
            classNamePrefix={classNamePrefix}
            options={options}
            isMulti={isMulti}
            isClearable={isClearableCheck ? isClearable : false}
            isDisabled={isDisabled}
            hideSelectedOptions={false}
            components={mergedComponents}
            styles={mergedStyles}
            placeholder={placeholder}
            isSearchable={true}
            onChange={onChange}
            value= {value}
            defaultValue={defaultValue}
            closeMenuOnSelect={!isMulti}
        />
    );
};

export default ReactSelectMultiSelect;
